// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectDialogCreatedMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_NEW_ORDER_MESSAGE);
        this.DialogId = 0;
        this.Pin = null;
    }
}
